import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Icon, Checkbox, Toast } from 'antd-mobile';
import tips from 'tips';

import urlConfig from 'Url';
import queryString from 'query-string';
import './index.less';
import Btn from 'Btn';
import pic from './assets/member.png';
import ratePopup from '../RatePopup';

const CheckboxItem = Checkbox.CheckboxItem;

let popPwdQueue = [];

class MemberComponent extends Component {
  state = {
    value: {},
    checked: false,
    status: '',
    checkItem: [],
    checkedPagName: '',
  };

  // _arr = [];

  static props = {
    title: PropTypes.string,
    destroy: PropTypes.func,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    lang: PropTypes.object,
  };

  static defaultProps = {
    destroy: () => {},
    getList: () => {},
    onConfirm: destroy => {
      destroy && destroy();
    },
    onCancel: (destroy, toHome) => {
      toHome && toHome();
      destroy && destroy();
    },
  };

  changeData = (e, val) => {
    if (e.target.checked) {
      this.setState({
        checkedPagName: val.pagName,
        value: val,
      });
    } else {
      this.setState({
        checkedPagName: '',
        value: '',
      });
    }
  };

  //后续优化 如果要选择多个非会员则对数据进行处理
  // onChange = (e, val) => {
  //   const { memberList } = this.props;
  //   if (e.target.checked) {
  //     this._arr.push(val);
  //   } else {
  //     this._arr = this._arr.filter(item => item.pagName !== val.pagName);
  //   }
  // };

  render() {
    const {
      onCancel,
      onConfirm,
      destroy,
      memberList,
      toHome,
      lang,
    } = this.props;
    const { value } = this.state;
    return (
      <section className="pop-pwd">
        <div
          id="popD"
          className="pop-pwd-content"
          role="dialog"
          tabIndex="-1"
          aria-modal="true"
        >
          <p className="memberTitle">{lang.tips}</p>
          <Icon
            type="cross"
            onClick={e => onCancel(destroy)}
            role="button"
            aria-label="关闭"
          />
          <div className="memberImg">
            <img src={pic} alt="" />
          </div>
          <p className="isNotMem">{lang.memberShip1}:</p>
          {memberList.map((item, i) => {
            return (
              <div className="memberlist" key={i}>
                <div className="leftButton">
                  <CheckboxItem
                    key={i}
                    checked={item.pagName === this.state.checkedPagName}
                    onChange={e => this.changeData(e, item)}
                  >
                    {item.pagName}
                  </CheckboxItem>
                </div>
              </div>
            );
          })}
          {/* {memberList.map((item, i) => (
            <CheckboxItem key={i} onChange={e => this.onChange(e, item)}>
              {item.pagName}
            </CheckboxItem>
          ))} */}
          <p>{lang.memberShip2}</p>
          <div className="pop-btn">
            <Btn text={lang.refCupon33} onClick={e => onConfirm(value)} />
            <Btn text={lang.skip} onClick={e => onCancel(destroy, toHome)} />
            {/* <Btn text="跳过" onClick={e => onCancel(destroy)} /> */}
          </div>
        </div>
      </section>
    );
  }
}

function getSessionMessage(key) {
  const persist = sessionStorage.getItem('persist:emp');
  const _store = persist ? JSON.parse(persist) : {};
  const app = _store.App ? JSON.parse(_store.App) : {};
  return app.memberList ? app.memberList[key] : {};
}

function setSessionMessage(data, key) {
  const persist = sessionStorage.getItem('persist:emp');
  const store_a = JSON.parse(persist);
  const store_b = JSON.parse(
    JSON.parse(sessionStorage.getItem('persist:emp')).App
  );
  store_b.memberList = Object.assign({}, { [key]: data });
  store_a.App = JSON.stringify(store_b);
  sessionStorage.setItem('persist:emp', JSON.stringify(store_a));
}

function renderNode(props) {
  let div = document.createElement('div');
  document.body.appendChild(div);

  let timeoutEvn = null;
  function keydownFun(e) {
    let dom = document.getElementById('popD');
    const focusableElements = dom.getElementsByTagName('*');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement =
      focusableElements[focusableElements.length - 1];
    let isTabPressed =
      e.key === 'Tab' || (e.shiftKey && e.key === 'Tab') || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // 如果Shift键被按下，向回切换焦点
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向后切换行为
      }
    } else {
      // 否则向前切换焦点
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向前切换行为
      }
    }
  }
  const destroy = () => {
    if (!div) return;
    clearTimeout(timeoutEvn);
    document.removeEventListener('keydown', keydownFun);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    ReactDOM.unmountComponentAtNode(div);
    document.body.removeChild(div);
    div = null;
  };

  const onConfirm = psg => {
    if (Object.keys(psg).length === 0) {
      Toast.info(props.lang.changeMember.checkMember, 1);
      return;
    }
    const query = queryString.stringify({
      pagName: psg.pagName,
      keyMem: props.cacheKey,
    });

    // //当前修改
    // if (psg.length === 0) {
    //   Toast.info(lang.changeMember.checkMember, 1);
    //   return;
    // }
    let url = encodeURIComponent(window.location.href);
    if (window.location.href.indexOf('pagName') === -1) {
      url = encodeURIComponent(window.location.href + '&' + query);
      if (window.location.href.indexOf('?') === -1) {
        url = encodeURIComponent(window.location.href + '?' + query);
      }
    } else {
      url = encodeURIComponent(window.location.href.split('keyMem')[0] + query);
    }

    window.location.href = `${
      urlConfig.msky_url
    }?lang=zh&enrollmentSourceCode=MOBILE&needMemberNo=true&clientId=RCP&encryptValue=${
      psg.encryptValue
    }&toPage=${url}`;
  };

  ReactDOM.render(
    <MemberComponent
      {...props}
      destroy={destroy}
      onConfirm={onConfirm}
      toHome={props.toHome}
    />,
    div
  );

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('popD').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  function trapFocus() {
    document.addEventListener('keydown', keydownFun);
  }
  timeoutEvn = setTimeout(() => {
    focus();
    trapFocus();
  }, 200);
  popPwdQueue.push(destroy);
  return popPwdQueue[popPwdQueue.length - 1];
}

export default async function({
  getMemberList,
  query,
  crateNps,
  toHome,
  fdbParmas,
  lang,
}) {
  // 链接带有key并且缓存有值;
  // if (query.keyMem) {
  //   const memSession = getSessionMessage(query.keyMem);
  //   // 更新缓存
  //   if (memSession.length) {
  //     memSession.forEach(item => {
  //       if (item.pagName === query.pagName) {
  //         item.memberNo = query.memberNo;
  //         return item;
  //       }
  //       return item;
  //     });
  //     setSessionMessage(memSession, query.keyMem);
  //   }
  //   // 存在非会员
  //   const non_member = memSession.filter(item => !item.memberNo);
  //   if (non_member.length !== 0) {
  //     renderNode({
  //       memberList: non_member,
  //       cacheKey: query.keyMem,
  //       toHome: toHome,
  //     });
  //   } else {
  //     toHome && toHome();
  //   }
  //   return false;
  // }

  // if (!query.keyMem && memSession) {
  //   return;
  // }

  if (query.vipMember !== 'Y') {
    // ratePopup(toHome);
    toHome && toHome();
    return false;
  }

  let {
    payload: { data },
  } = await getMemberList({ orderNo: query.orderNo });
  let memberList = data;
  if (!memberList || memberList.status === 500) {
    toHome && toHome();
    return false;
  }
  let fdbDtat = '';
  if (!query.orderNo.includes('GO')) {
    fdbDtat = await crateNps(fdbParmas);
  }
  if (!memberList.data) {
    if (
      fdbDtat &&
      fdbDtat.payload.data.code == '0000' &&
      !fdbDtat.payload.data.decryptStr.includes('finish')
    ) {
      window.location.href = fdbDtat.payload.data.decryptStr;
    } else {
      let div = document.createElement('div');
      document.body.appendChild(div);
      const destroy = () => {
        if (!div) return;
        ReactDOM.unmountComponentAtNode(div);
        document.body.removeChild(div);
        div = null;
      };
      destroy();
      toHome && toHome();
    }
    return false;
  }

  const key = query.orderNo;
  const dataCache = memberList.data.map(function(item) {
    return {
      pagName: item.pagName,
      encryptValue: item.idCard,
      memberNo: item.hasMember,
    };
  });
  const no_member = dataCache.filter(item => item.memberNo);
  // 存缓存
  setSessionMessage(no_member, key);
  if (no_member.length !== 0) {
    renderNode({
      memberList: no_member,
      cacheKey: key,
      toHome: () => {
        if (
          fdbDtat &&
          fdbDtat.payload.data.code == '0000' &&
          !fdbDtat.payload.data.decryptStr.includes('finish')
        ) {
          window.location.href = fdbDtat.payload.data.decryptStr;
        } else {
          let div = document.createElement('div');
          document.body.appendChild(div);
          const destroy = () => {
            if (!div) return;
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
            div = null;
          };
          destroy();
          toHome && toHome();
        }
      },
      lang,
    });
  } else {
    if (
      fdbDtat &&
      fdbDtat.payload.data.code == '0000' &&
      !fdbDtat.payload.data.decryptStr.includes('finish')
    ) {
      window.location.href = fdbDtat.payload.data.decryptStr;
    } else {
      let div = document.createElement('div');
      document.body.appendChild(div);
      const destroy = () => {
        if (!div) return;
        ReactDOM.unmountComponentAtNode(div);
        document.body.removeChild(div);
        div = null;
      };
      destroy();
      toHome && toHome();
    }
  }
}

// PopPwd.clear = () => {
//   if (popPwdQueue && popPwdQueue.length) {
//     popPwdQueue.forEach(progess => {
//       progess();
//     });
//     popPwdQueue = [];
//   }
// };



// WEBPACK FOOTER //
// ./src/components/MemberPopup/index.js